"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Router = void 0;
var _react = _interopRequireWildcard(require("react"));
var _msalBrowser = require("@azure/msal-browser");
var _msalReact = require("@azure/msal-react");
var _material = require("@mui/material");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _reactRouterDom = require("react-router-dom");
var _Layout = require("../components/shared/Layout/Layout");
var _DocumentManagementView = require("./DocumentManagementView/DocumentManagementView");
var _DocumentView = require("./DocumentView/DocumentView");
var _BackgroundContext = require("@/context/BackgroundContext");
var _TeamsAndChannelsContext = require("@/context/TeamsAndChannelsContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var StyledContainer = (0, _material.styled)("div")(function () {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    inset: "0",
    height: "100%",
    width: "100%"
  };
});
var Router = exports.Router = function Router() {
  var token = _jsCookie["default"].get("access_token");
  var _useTeamsAndChannels = (0, _TeamsAndChannelsContext.useTeamsAndChannels)(),
    msalConfig = _useTeamsAndChannels.msalConfig;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    msalInstance = _useState2[0],
    setMsalInstance = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    msalReady = _useState4[0],
    setMsalReady = _useState4[1];
  (0, _react.useEffect)(function () {
    if (msalConfig) {
      var instance = new _msalBrowser.PublicClientApplication(msalConfig);
      instance.initialize().then(function () {
        setMsalInstance(instance);
        setMsalReady(true);
      });
    }
  }, [msalConfig]);
  if (!msalReady || !msalInstance) return /*#__PURE__*/_react["default"].createElement("div", null, "Loading Authentication...");
  if (!token) {
    return /*#__PURE__*/_react["default"].createElement(StyledContainer, {
      "data-testid": "progressBar"
    }, /*#__PURE__*/_react["default"].createElement(_material.CircularProgress, null));
  }
  if (msalReady && msalInstance) {
    return /*#__PURE__*/_react["default"].createElement(_msalReact.MsalProvider, {
      instance: msalInstance
    }, /*#__PURE__*/_react["default"].createElement(_BackgroundContext.BackgroundProvider, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.BrowserRouter, {
      basename: "doc_mgmt"
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Routes, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
      element: /*#__PURE__*/_react["default"].createElement(_Layout.Layout, null)
    }, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
      path: "/",
      element: /*#__PURE__*/_react["default"].createElement(_DocumentManagementView.DocumentManagementView, null)
    }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
      path: "/jump-start-knowledge-base",
      element: /*#__PURE__*/_react["default"].createElement(_DocumentManagementView.DocumentManagementView, null)
    }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
      path: "/document-viewer",
      element: /*#__PURE__*/_react["default"].createElement(_DocumentView.DocumentView, null)
    }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
      path: "*",
      element: /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Navigate, {
        to: "/",
        replace: true
      })
    }))))));
  }
};